import { IBooleanResponse } from '@gem/models/commonModel';
import { IUpdateDraftInputRequest } from '@gem/models/draftModel';
import { logger } from '@gem/modules/logger';

import { buildModelError } from '../error/errorBuilder';

// No need to BFF implement, this functionality has been closed by the feature flags
export const updateDraftInput = async (
  data: IUpdateDraftInputRequest
): Promise<IBooleanResponse> => {
  try {
    return Promise.resolve({ result: true });
  } catch (error) {
    logger.get('API').error('group.updateDraftInput', error);
    throw buildModelError(error);
  }
};
